export const Language = {
    PANEL_NAME: 'Document Automation',
    BUSINESS_TYPE: 'Business type',
    HELLO: 'Hello',
    BUSINESS_NAME: 'Business Name',
    DESCRIPTION: 'Description',
    COUNTRY_CODE: 'Country code',
    PHONE_NUMBER: 'Phone Number',
    URL: 'URL',
    GOOGLE_TITLE: 'Google Title',
    GOOGLE_KEYWORD: 'Google Keyword',
    GOOGLE_DESCRIPTION: 'Google Description',
    META_TITLE: 'Meta Title',
    META_KEYWORD: 'Meta Keyword',
    META_DESCRIPTION: 'Meta Description',
    SHORT_DESCRIPTION: 'Short Description',
    SHORT_DESCRIPTION_FOR_LISTING_PAGE:
        'Short Description For All Documents Listing Page',
    UPLOAD_PREVIEW_IMAGES: 'Upload Preview Images',
    ACTIVE: 'Active',
    ACTIVATE: 'Activate',
    INACTIVATE: 'Inactivate',
    THUMBNAIL: 'Thumbnail',
    INACTIVE: 'Inactive',
    DELETE: 'Delete',
    YES: 'Yes',
    NO: 'No',
    PRICE: 'Price',
    ENGLISH: 'English',
    GERMAN: 'German',
    SELECT_LANGUAGE: 'Select Language',
    INVALID_LANGUAGE_SELECTED: 'Invalid language selected',
    DELETED: 'Deleted',
    COPIED: 'Copied',
    SOMETHING_IS_WRONG: 'Something is wrong',
    SAVE: 'Save',
    DOCUMENT_TYPE: 'Document Type',
    FILLED_DOCUMENT: 'Filled Document',
    DOCUMENT_TEMPLATE_ONLY: 'Template Only not filled',
    NAME: 'Name',
    CANNOT_LOAD_BUSINESSES_TECHNICAL_ERROR:
        'Cannot fetched businesses. Technical Error.',
    CREATED_ON: 'Created On',
    DOCUMENTS: 'Documents',
    SERIAL_NUMBER: 'Serial No.',
    REQUEST_TYPE: 'Request Type',
    CONTACT_REQUEST: 'Contact Request',
    CALLBACK_REQUEST: 'Callback Request',
    DELETE_CONFIRMATION: 'Are you sure you want to delete this ?',
    MARK_AS_DONE_CONFIRMATION: 'Are you sure you want to mark this as done ?',
    CLOSE: 'Close',
    EMAIL: 'Email',
    MESSAGE: 'Message',
    DONE: 'Done',
    CONTACTS: 'Contacts',
    DOCUMENT_TEMPLATES: 'Document Templates',
    IS_DONE: 'Is Done?',
    KEYWORD: 'Keyword',
    ARTICLES: 'Articles',
    EDIT_ARTICLE: 'Edit Article',
    ARTICLE_UPDATED_SUCCESSFULLY: 'Article updated successfully',
    ACTIVATED_SUCCESSFULLY: 'Activated successfully',
    CREATE_ARTICLE: 'Create Article',
    INVALID_EMAIL_OR_PASSWORD: 'Invalid email or password',
    DASHBOARD: 'Dashboard',
    STATS: 'Stats',
    LOGIN: 'Login',
    READ_MORE: 'Read More',
    READ_LESS: 'Read Less',
    NAME_REQUIRED: 'Name is required',
    PRICE_REQUIRED: 'Price is required',
    ENTER_VALID_PRICE: 'Please enter a valid price',
    OUTSIDEPRICE_REQUIRED: 'Outside price is required',
    ENTER_VALID_OUTSIDEPRICE: 'Please enter a valid outside price',
    PREPARATION_TIME_REQUIRED: 'Preparation time is required',
    ENTER_VALID_PREPARATION_TIME: 'Please enter a valid preparation time',
    OUTSIDE_PRICE: 'Outside Price',
    PREPARATION_TIME_MINUTES: 'Preparation Time (minutes)',
    PREPARATION_TIME: 'preparationTime',
    CREATE: 'Create',
    ENTER_PRICE: 'Enter price',
    ENTER_OUTSIDE_PRICE: 'Enter outside price',
    ENTER_PREPARATION_TIME: 'Enter preparation time in minutes',
    FRENCH: 'French',
    DELETE_DOCUMENT: 'Delete Document',
    CANNOT_LOAD_DOCUMENT_TEMPLATES_ERROR:
        'Cannot fetched document templates. Technical Error.',
    NO_DOCUMENT_TEMPLATES: 'There is no document templates.',
    CREATE_HERE: 'Create here',
    CANNOT_CHANGE_DOCUMENT_TEMPLATES_STATUS_ERROR:
        'Cannot change document template status. Technical Error.',
    CANNOT_CHANGE_DOCUMENT_TEMPLATES_TRANSLATION_STATUS_ERROR:
        'Cannot change document template translation status. Technical Error.',
    UPDATED: 'Updated',
    DOCUMENT_ADDED_SUCCESSFULLY: 'Document added successfully.',
    EDIT_DOCUMENT: 'Edit Document',
    DOCUMENT_UPDATED_SUCCESSFULLY: 'Document updated successfully.',
    UPDATE_BUTTON: 'Update',
    SEARCH_TEMPLATES: 'Search templates...',
    PREPARATION_TIME_: 'Preparation Time',
    MINUTES: 'minutes',
    DOCUMENT_TEMPLATE_TRANSLATION: 'Document Template Translation',
    DOCUMENT_TITLE_REQUIRED: 'Document title required',
    URL_REQUIRED: 'Url required',
    URL_SHOULD_NOT_CONTAIN_WHITE_SPACE:
        'Url should not contain white space, numbers, symbols and underscore',
    GOOGLE_TITLE_REQUIRED: 'Google title required',
    GOOGLE_KEYWORD_REQUIRED: 'Google keyword required',
    GOOGLE_DESCRIPTION_REQUIRED: 'Google description required',
    YOUTUBE_LINK_NOT_VALID: 'Youtube link not valid',
    DOCUMENT_TEXT_REQUIRED: 'Document text required',
    SHORT_DESCRIPTION_REQUIRED: 'Short description required',
    DESCRIPTION_REQUIRED: 'Description required',
    FAQS_REQUIRED: 'FAQs required',
    DOCUMENT_TITLE: 'Document Title',
    ENTER_DOCUMENT_TITLE: 'Enter document title',
    ENTER_GOOGLE_TITLE: 'Enter google title',
    ENTER_GOOGLE_DESCRIPTION: 'Enter google description',
    YOUTUBE_LINK: 'Youtube Link',
    ENTER_YOUTUBE_VIDEO_LINK: 'Enter YouTube video link',
    DOCUMENT_TEXT: 'Document Text',
    ENTER_SHORT_DESCRIPTION: 'Enter short description',
    FAQS: 'FAQs',
    ADD_FAQ: 'Add FAQ',
    QUESTION: 'Question',
    ANSWER: 'Answer',
    BOTH_VALUES_REQUIRED: 'Both values are required',
    REMOVE_FAQ: 'Remove FAQ',
    UNABLE_TO_FETCH_TRANSLATION_DATA:
        'Unable to fetch translation data. Technical Error.',
    UNABLE_TO_IMAGE: 'Unable to upload image. Technical Error.',
    SEARCH_ARTICLES: 'Search articles...',
    IS_FOOTER_LINK: 'Is footer link?',
    DELETE_ARTICLE: 'Delete Article',
    ENTER_ARTICLE_NAME: 'Enter article name',
    CREATE_DOCUMENT: 'Create Document',
    DOCUMENT_NAME_PLACEHOLDER: 'Ex. Power of attorney',
    SAVE_DOCUMENT: 'Save Document',
    UPDATE_DOCUMENT: 'Update Document',
    PRICE_IN_CHF: 'Price (CHF)',
    OUTSIDE_PRICE_IN_CHF: 'Outside price (CHF)',
    OUTSIDE_PRICE_HINT:
        'Outside Price is the price a user would pay if they choose the traditional process with lawyers to create this document.',
    PRICE_HINT: 'Price for this document',
    PREPARATION_TIME_HINT:
        'Estimated time required to prepare document, in minutes.',
    META_TITLE_HINT:
        'Provide a concise title for the document (up to 300 characters) that accurately reflects its content for search engines.',
    META_KEYWORD_HINT:
        'Enter relevant keywords (separated by commas) that describe the document’s content to improve search engine visibility.',
    META_DESCRIPTION_HINT:
        'Write a brief summary (up to 1000 characters) of the document’s content. This description will appear in search engine results. [Note : New line will not be allowed]',
    KEYWORD_SHOULD_CONTAIN_COMMA_SEPERATED:
        'Google keyword should contain comma seperated words',
    META_KEYWORD_PLACEHOLDER: 'Ex. Keyword 1, Keyword 2, Keyword 3...',
    YOUTUBE_HINT: 'Ex. https://www.youtube.com/embed/4fUSkwSeCgQ',
    DOCUMENT_TEXT_HINT:
        'Enter the main content of the document. You can use placeholders (like [[NAME]], [[EMAIL]], etc.) which will be automatically replaced with user details when generating the final PDF.',
    BLURRED_PREVIEW_IMAGE_HINT:
        'Uploaded images will be used as blurred background previews during the document creation process on the website. Please upload images with a height of 1047 px ± 30 px and a width of 720 px ± 30 px for the best results.',
    SHORT_DESCRIPTION_HINT:
        'Enter a short description of the document. This will be shown below the document name when the user selects a document to create a PDF. [Note : New line will not be allowed.]',
    DESCRIPTION_HINT:
        'Enter a detailed description of the document. This will be shown to the user before they start creating the document.',
    DELETE_CONFIRMATION_WITH_DOCUMENT_NAME: 'Are you sure you want to delete',
    IN: 'In',
    IS_FOOTER_LINK_HINT:
        'Select "Yes" if you want this article to appear as a link in the footer section of the website. Typically used for important pages like Terms & Conditions, Privacy Policy, etc.',
    CANNOT_CHANGE_ARTICLE_STATUS_ERROR:
        'Cannot change article status. Technical Error.',
    CANNOT_LOAD_ARTICLE_ERROR: 'Cannot fetched articles. Technical Error.',
    NO_ARTICLE: 'There is no articles.',
    ARTICLE_TRANSLATION: 'Article translation',
    ARTICLE_TITLE: 'Article Title',
    ENTER_ARTICLE_TITLE: 'Enter article title',
    ARTICLE_TITLE_REQUIRED: 'Article title required',
    SAVE_ARTICLE: 'Save Article',
    UPDATE_ARTICLE: 'Update Article',
    ARTICLE_META_TITLE_HINT:
        'Provide a concise title for the article (up to 300 characters) that accurately reflects its content for search engines.',
    ARTICLE_META_KEYWORD_HINT:
        'Enter relevant keywords (separated by commas) that describe the article’s content to improve search engine visibility.',
    ARTICLE_META_DESCRIPTION_HINT:
        'Write a brief summary (up to 1000 characters) of the article’s content. This description will appear in search engine results.',
    ARTICLE_SHORT_DESCRIPTION_HINT: 'Enter a short description of the article.',
    ARTICLE_DESCRIPTION_HINT:
        'Enter a detailed description of the article. This will be shown to the user when they visit this article link.',
    ARTICLE_THUMBNAIL_IMAGE: 'Article Thumbnail Image',
    INVALID_THUMBNAIL_FILE_TYPE:
        'Invalid file type. Only JPEG, JPG, PNG, GIF, and WEBP are allowed.',
    THUMBNAIL_FILE_LARGE:
        'File is too large. Maximum size allowed is 2048 KB (2 MB).',
    THUMBNAIL_REQUIRED: 'Thumbnail required.',
    UPLOAD_IMAGE: 'Upload image',
    PREVIEW_END_REQUIRED:
        'Document Text must include the [[PREVIEW_END]] placeholder. This placeholder is required to mark where the preview ends for unpaid users.',
    DUPLICATE_PLACEHOLDERS: 'Duplicate placeholders found: ',
    TRANLSATION_DELETE_CONFIRMATION:
        'By deleting this document template, following document template translations will be deleted : ',
    DRAFTS: 'Drafts',
    CANNOT_LOAD_DOCUMENT_DRAFTS_ERROR:
        'Cannot fetched document drafts. Technical Error.',
    LANGAUGE: 'Language',
    SEE_DOCUMENT: 'See Document',
    DOWNLOAD_DOCUMENT: 'Download Document',
    DOWNLOAD_INVOICE: 'Download Invoice',
    NO_DOCUMENTS_CREATED: 'No documents created yet.',
    NO_DRAFT_DOCUMENTS: 'No draft documents available.',
    ERROR_DOWNLOADING_DOCUMENT: 'Error downloading document.',
    ERROR_DOWNLOADING_INVOICE: 'Error downloading invoice.',
    REQUIRED_PLACEHOLDER_MISSING: 'Required placeholder missing',
    HOWTO_USE_DESCRIPTION_PLACEHOLDER:
        'How to use placeholders in the description:',
    CTA_BANNER: '[[CTA_BANNER]]',
    DOCUMENT_STEPS: '[[DOCUMENT_STEPS]]',
    CTA_BANNER_HINT:
        ' - [Required] This will display the pricing CTA banner with a button (see image below).',
    DOCUMENT_STEPS_HINT:
        ' – [Required] This will show a visual step-by-step document info block (see image below).',
    PLACE_PLACEHOLDERS:
        '➡️ Just place these placeholders where you want them to appear in the description content.',
    DOCUMENT_ACTIVED_SUCCESSFULLY: 'Document activated successfully',
    DOCUMENT_INACTIVED_SUCCESSFULLY: 'Document inactivated successfully',
    CUSTOMER: 'Customer',
    LOADING_: 'Loading...',
    LOADMORE: 'Load More',
    KEYWORDS: 'Keywords',
    NO_KEYWORDS_FOUND: 'No keywords found.',
    CANNOT_LOAD_KEYWORDS_ERROR: 'Cannot fetched keywords. Technical Error.',
    COUNT: 'Count',
    DELETED_SUCCESSFULLY: 'Deleted successfully',
    INACTIVATED_SUCCESSFULLY: 'Inactivated successfully',
    USE_OTHER_LANGUAGE_TEXT: 'Use other language text',
    WHICH_DOCUMENT_TEMPLATE_TRANSLATION:
        "Which document template translation's document text you want to use?",
    SELECT_DOCUMENT_TEMPLATE_TRANSLATION:
        'Select Document Template Translation',
    UNABLE_TO_FETCH_OTHER_TRANSLATION_DATA:
        'Unable to fetch other translation data. Technical Error.',
    PLEASE_SELECT_VALID_DOCUMENT_TEMPLATE_TRANSLATION:
        'Please select a valid document template translation.',
    UPLOAD_PREVIEW_IMAGES_NOTE:
        'Please note: After uploading, deleting, or reordering images, you must click "Save Document" or "Update Document" to apply the changes.',

    UPLOAD_IMAGE_FORMAT_VALIDATION:
        'Only PNG, JPG, JPEG, and WEBP images are allowed.',
    UPLOAD_IMAGE_DIMENSION_VALIDATION_MESSAGE:
        'Image dimensions must be approximately 1047px height and 720px width (±30px allowed).',
    UPLOAD_FAQ_NOTE:
        'Please note: After uploading, deleting, or reordering FAQs, you must click "Save Document" or "Update Document" to apply the changes.',
    INCLUDING_VAT: '(Incl. VAT)',
    SHOW_DEV_DOCUMENTS: 'Show Dev Documents',
    UNAUTHORIZED: 'UnAuthorized',
    TOKEN_IS_INVALID: 'Token is Invalid',
    UNAUTHORIZED_ACCESS: 'Unauthorized Access',
    YOU_DONT_HAVE_PERMISSION: 'You don’t have permission to view this page.',
    PLEASE_LOGIN_WITH_VALID_ADMIN_ACCOUNT:
        'Please log in with a valid admin account.',
    REFERRER: 'Referrer',
    GOOGLE_ADS: 'Google Ads',
    VIEW: 'View',
    UTM_PARAMETERS: 'UTM Parameters',
    PARAMETER: 'Parameter',
    VALUE: 'Value',
    IP_ADDRESS: 'IP Address',
    WHERE_THIS_APPEARS_ON_WEBSITE: 'Where this appears on website',
    FIELD_PREVIEW_DESCRIPTION:
        'This image shows where the value will appear on the front-end website.',
    WHERE_IS_THIS_SHOWN: 'Where is this shown?',
    BANNER_HEADING: 'Banner Heading',
    DOCUMENT_HIGHLIGHTS: 'Document Highlights',
    DOCUMENT_BENEFITS: 'Document Benefits',
    TITLE: 'Title',
    BENEFIT: 'Benefit',
    HIGHLIGHT: 'Highlight',
    PAGE_HEADING: 'Page Heading',
    BANNER_HEADING_VALIDATION: 'Banner heading required',
    ALL_HIGHLIGHTS_REQUIRED: 'All Highlights required',
    ALL_BENEFITS_REQUIRED: 'All Benefits required',
    PAGE_HEADING_REQUIRED: 'Page heading required',
    DOCUMENT_TEMPLATE_TEXT: 'Document Template Text',
    DOCUMENT_DETAIL_PAGE: 'Document Detail Page',
    CREATE_DOCUMENT_PAGE: 'Create Document Page',
    UPLOAD_IMAGE_UPPERCASE: 'Upload Image',
    DOCUMENT_GROUP_PAGES: 'Document Group Pages',
    CANCEL: 'Cancel',
    SEARCH_DOCUMENT_GROUP: 'Search document group...',
    CREATE_DOCUMENT_GROUP_PAGE: 'Create Document Group Page',
    EDIT_DOCUMENT_GROUP_Page: 'Edit Document Group Page',
    DOCUMENT_NAME_CATEGORY_PLACEHOLDER: 'Ex. Power of attornies',
    DOCUMENT_GROUP_PAGE_NAME: 'Document Group Page Name',
    DOCUMENT_GROUP_PAGE_NAME_REQUIRED: 'Document group page name is required',
    EDIT_DOCUMENT_GROUP_PAGE: 'Edit Group Page',
    NO_DOCUMENT_GROUP_PAGES: 'There is no document group pages.',
    DOCUMENT_GROUP_PAGES_TRANSLATION: 'Document Group Pages Translation',
    HEADING: 'Heading',
    DOCUMENT_CATEGORY_DESCRIPTION_HINT:
        'Enter a short description of the category. This will be shown below the category heading when the user open any document category page. [Note : New line will not be allowed.]',
    CATEGORY_PAGE_META_TITLE_HINT:
        'Provide a concise title for the document category (up to 300 characters) that accurately reflects its content for search engines.',
    CATEGORY_PAGE_META_KEYWORD_HINT:
        'Enter relevant keywords (separated by commas) that describe the document category’s content to improve search engine visibility.',
    CATEGORY_PAGE_META_DESCRIPTION_HINT:
        'Write a brief summary (up to 1000 characters) of the document category’s content. This description will appear in search engine results. [Note : New line will not be allowed]',
    HEADING_REQUIRED: 'Heading required',
    SAVE_DOCUMENT_GROUP_PAGE: 'Save Document Group Page',
    UPDATE_DOCUMENT_GROUP_PAGE: 'Update Document Group Page',
    CANNOT_LOAD_DOCUMENT_GROUP_PAGES_ERROR:
        'Cannot fetched document group pages. Technical Error.',
    DELETE_DOCUMENT_GROUP_PAGE: 'Delete Document Group Page',
    CATEGORY_DELETE_CONFIRMATION:
        'By deleting this document group page, following document group page translations will be deleted : ',
    CANNOT_CHANGE_DOCUMENT_GROUP_PAGE_STATUS_ERROR:
        'Cannot change document group page status. Technical Error.',
    DOCUMENT_GROUP_PAGE_TRANSLATION_ACTIVATED_SUCCESSFULLY:
        'Document group page translation activated successfully',
    DOCUMENT_GROUP_PAGE_TRANSLATION_INACTIVATED_SUCCESSFULLY:
        'Document group page translation inactivated successfully',
    CANNOT_CHANGE_DOCUMENT_GROUP_PAGE_TRANSLATION_STATUS_ERROR:
        'Cannot change document group page translation status. Technical Error.',
    DOCUMENT_TEMPLATE_REQUIRED: 'Document template is required',
    PREVIEW: 'Preview',
    TITLE_REQUIRED: 'Title required',
    CREATE_DOCUMENT_URL: 'Create Document URL',
    DOCUMENT_DETAIL_URL: 'Document Detail URL',
    VISIBLE_ON_DOCUMENT_DETAIL_PAGE: 'Visible on document detail page ?',
    SEE_PREVIEW: 'See preview',
    WITH: 'with',
    WITHOUT: 'without',
    SPECIAL_INSTRUCTION : 'Special Instruction',
    ENTER_SPECIAL_INSTRUCTION : 'Enter Special Instruction',
    DOWNLOAD_DOCUMENT_TEMPLATE_ONLY_SETTINGS: 'Downlod Document Template Only Settings',
    UPLOAD_DOCUMENT_TEMPLATE_PDF: 'Upload Document Template PDF',
    UPLOAD_DOCUMENT_TEMPLATE_PREVIEW_IMAGES: 'Upload Document Template Preview Images',
    PDF_DOWNLOAD: 'Download PDF',
    PDF_DELETE: 'Delete PDF',
    PDF_DELETE_CONFIRMATION: 'Are you sure you want to delete this PDF file?',
    TOTAL: 'Total',
    LAST_40_DAYS_DRAFTS_VS_DOCUMENTS: '- Last 40 Days (Documents vs Drafts)',
    LAST_14_MONTHS_DRAFTS_VS_DOCUMENTS: '- Last 14 Months (Documents vs Drafts)',
    FILLED_DOCUMENTS: 'Filled Documents',
    LAST_40_DAYS_FILLED_DRAFTS_VS_DOCUMENTS: '- Last 40 Days (Filled Documents flow drafts vs success)',
    LAST_14_MONTHS_FILLED_DRAFTS_VS_DOCUMENTS: '- Last 14 Months (Filled Documents flow drafts vs success)',
    TEMPLATE_ONLY_NOT_FILLED: 'Template Only Not Filled',
    LAST_40_DAYS_TEMPLATE_ONLY_DRAFTS_VS_DOCUMENTS: '- Last 40 Days (Template Only Not Filled flow drafts vs success)',
    LAST_14_MONTHS_TEMPLATE_ONLY_DRAFTS_VS_DOCUMENTS: '- Last 14 Months (Template Only Not Filled flow drafts vs success)',
    PAYMENTS: 'Payments',
    PAYMENT_NOT_COMPLETED: 'Payment Not Completed',
    PAYMENT_SUCCESS: 'Payment Success',
    LAST_40_DAYS_PAYMENT_SUCCESS_VS_NOT_COMPLETED: '- Last 40 Days (Payment Success vs Payment Not Completed)',
    LAST_14_MONTHS_PAYMENT_SUCCESS_VS_NOT_COMPLETED: '- Last 14 Months (Payment Success vs Payment Not Completed)',
    FEEDBACKS: 'Feedbacks',
    ATTACHMENTS: 'Attachments',
    NO_RECORD_FOUND: 'No record found',
    PDF: 'PDF',
    MESSAGE_CANNOT_BE_EMPTY: 'Message cannot be empty.',
    MESSAGE_CONTAINS_INVALID_HTML_OR_JAVASCRIPT: 'Message contains invalid HTML or Javascript code.',
    MARK_AS_READ: 'Mark As Read',
    READ: 'Read',
    REPLY: 'Reply',
    REPLY_TO: 'Reply to',
    TYPE_YOUR_REPLY_MESSAGE_HERE: 'Type your reply message here...',
    SENDING: 'Sending...',
    SEND: 'Send',
    SHOW_FILL_FORM_OPTION: 'Show Fill Form Option',
    SHOW_PDF_TEMPLATE_DOWNLOAD_OPTION: 'Show Pdf Template Download Option',
    PDF_REQUIRED_FOR_DOWNLOAD_OPTION: 'Please upload a PDF template file first to enable this option.',
    CUSTOMER_LOCATION: 'Customer Location (City/Country)',
    REPLIED: 'Replied',
    READ_BY: 'Read by',
    BY: 'by',
    SHOW_UNREAD_ONLY: 'Show Unread Only',
    USERS: 'Users',
    NEW_USERS_LAST_40_DAYS: '- Last 40 Days (New Users Created)',
    NEW_USERS_LAST_14_MONTHS: '- Last 14 Months (New Users Created)',
    PAYMENT_INITIATED: 'Payment Initiated',
    CUSTOMER_REVIEWS: 'Customer Reviews',
    REVIEW: 'Review',
    ADD_REVIEW: 'Add Review',
    REVIEWER_NAME: 'Reviewer Name',
    REVIEW_TEXT: 'Review Text',
    REVIEW_VALIDATION_ERROR: 'Validation Error',
    REVIEW_RATING_VALIDATION_RANGE: 'Rating must be between 4.0 and 5.0',
    REVIEWER_NAME_REQUIRED: 'Reviewer name is required',
    REVIEW_RATING_REQUIRED: 'Rating is required',
    REVIEW_TEXT_REQUIRED: 'Review text is required',
    ENTER_REVIEWER_NAME_PLACEHOLDER: 'Enter reviewer name (e.g. Jean-Pierre B., Genève)',
    ENTER_REVIEW_TEXT_PLACEHOLDER: 'Enter review text...',
    RATING_LABEL_WITH_RANGE: 'Rating (4.0 to 5.0)',
    NO_REVIEWS_ADDED_YET: 'No reviews added yet. Click the button below to add your first review.',
    SEO_KEYWORD_TAGS: 'SEO Keyword Tags',
    SEO_KEYWORD_TAGS_HINT: 'Add relevant keywords for this translation. Users searching these terms on Google will be routed to this document. Tags are optional.',
    TYPE_TAG_PLACEHOLDER: 'Type a tag and press Enter or Comma...',
    NO_TAGS_ADDED_YET: 'No tags added yet.',
    REMOVE_TAG: 'Remove tag',
};
